import { render, staticRenderFns } from "./IntelbrasEventData.vue?vue&type=template&id=42b14a4a&scoped=true"
import script from "./IntelbrasEventData.vue?vue&type=script&lang=js"
export * from "./IntelbrasEventData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b14a4a",
  null
  
)

export default component.exports